import { useState, useContext, useEffect } from "react";
import { Row, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge } from "react-bootstrap";

import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
import moment from "moment";
import { UserContext } from "../../common";
import HelpMatForm from "./HelpMatForm";

import MessageModal from "../../components/MessageModal";
import ChoosePlans from "../../components/application/ChoosePlans";
import VideoPlayer from "../../components/application/VideoPlayer";

const HelpMatManage = (props) => {
  const { userData } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ jcats: [], jobs: [], help: [] });
  const [mode, setMode] = useState(0);
  const [selectedData, setSelectedData] = useState({});
  const [filter, setFilter] = useState({ start: 0, limit: 10, job: 0 });
  const [message, setMessage] = useState(false);
  const [showVideo, setShowVideo] = useState("");
  const [jcat, setJCat] = useState(0);
  const [jobing, setJobing] = useState(false);

  const fetchHelpMaterials = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchhelpmats") + `?jcat=${jcat}&job=${filter.job}&pulljcats=${data.jcats.length === 0 ? 1 : 0}`, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          let tmp = { help: _.get(res, "data.help", []) };
          if (_.get(res, "data.jcats", false)) {
            tmp["jcats"] = res.data.jcats;
            tmp["jobs"] = [];
          }
          if (_.get(res, "data.jobs", false)) {
            tmp["jobs"] = res.data.jobs;
          } else if (parseInt(jcat) === 0) {
            tmp["jobs"] = [];
          }
          setData({ ...data, ...tmp });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchHelpMaterials, [filter]);

  const fetchJobsByCat = () => {
    if (jcat > 0) {
      setJobing(true);
      axios
        .get(Utils.apiUrl(`users/fetchjobsbycat/${jcat}`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setData({ ...data, jobs: res.data.jobs });
          }
          setJobing(false);
        })
        .then(fetchHelpMaterials)
        .catch((err) => {
          setJobing(false);
          console.log(err);
        });
    } else {
      fetchHelpMaterials();
    }
  };

  useEffect(fetchJobsByCat, [jcat]);

  const afterSave = (res) => {
    setMessage({
      type: res.success ? "info" : "error",
      message: _.isObject(res.message) ? Object.values(res.message).join(",") : res.message,
    });
    if (res.success) {
      setMode(0);
      setSelectedData(false);
      fetchHelpMaterials();
    }
  };

  const toggleData = (e, d) => {
    console.log(d);
    if (
      window.confirm(`You are going to ${d.is_active === "1" ? "de" : ""}activate this ${d.type == "help" ? "Help Material" : "Resource"}, continue?`)
    ) {
      axios
        .post(Utils.apiUrl("users/toogleresource"), `id=${d.id}`, Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setMessage({ type: "success", message: res.data.message });
            fetchHelpMaterials();
          }
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      e.preventDefault();
    }
  };

  const handleDelete = (e, d) => {
    if (window.confirm(`You are going to delete this ${d.type == "help" ? "Help Material" : "Resource"}, continue?`)) {
      axios
        .delete(Utils.apiUrl(`users/deleteresource/${d.id}`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setMessage({ type: "success", message: res.data.message });
            fetchHelpMaterials();
          }
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      e.preventDefault();
    }
  };

  if (!_.get(userData, "is_super_user", false)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  const showVideoDialog = () => (
    <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={showVideo !== ""} onHide={() => setShowVideo("")}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Video Help Material</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3" style={{ background: "#F8FAFC" }}>
        <VideoPlayer src={showVideo} title="Video Help Material" />
      </Modal.Body>
    </Modal>
  );

  return (
    <>
      <Row className="px-2 mt-2 mb-3">
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/users`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Users
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/roles`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Manage Roles
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/helpmat`} className="w-100 btn btn-primary py-2 fw-bold">
            Manage Help Materials
          </a>
        </Col>
        <Col xs={6} sm={3} className="p-1">
          <a href={`${process.env.PUBLIC_URL}/userDocument`} className="w-100 btn py-2 fw-bold" style={{ backgroundColor: "#c6ddff", color: "var(--dt-navy)" }}>
            Staff Documents
          </a>
        </Col>
      </Row>

      <div className="p-3 bg-white">
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">Fetching Help Materials</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}
        {!loading && (
          <>
            {mode !== 0 && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>{["", "Add", "Edit"][props.mode]} Help Material</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="secondary" onClick={() => setMode(0)}>
                      Back
                    </Button>
                  </Col>
                </Row>
                <HelpMatForm mode={mode} jcats={data.jcats} jcat={jcat} data={selectedData} afterSave={afterSave} />
              </>
            )}

            {mode === 0 && (
              <>
                <Row>
                  <Col xs={3}>
                    <h2>Help Materials</h2>
                  </Col>
                  <Col xs={3}>
                    <select
                      className="form-select"
                      onChange={(e) => {
                        setJCat(parseInt(e.currentTarget.value));
                        if (parseInt(e.currentTarget.value) === 0) {
                          setFilter({ ...filter, job: 0 });
                        }
                      }}
                    >
                      <option value="0" selected={jcat === 0}>
                        Any Job Category
                      </option>
                      {data.jcats.length > 0 &&
                        data.jcats.map((jc) => (
                          <option key={jc.id} value={jc.id} selected={jcat === parseInt(jc.id)}>
                            {jc.name}
                          </option>
                        ))}
                    </select>
                  </Col>
                  <Col xs={3}>
                    {jobing && (
                      <Alert variant="light" className="p-1 px-3">
                        Fetching Jobs..
                      </Alert>
                    )}

                    {!jobing && (
                      <select className="form-select" onChange={(e) => setFilter({ ...filter, job: parseInt(e.currentTarget.value) })}>
                        <option value="0" selected={filter.job === 0}>
                          Any Job
                        </option>
                        {data.jobs.length > 0 &&
                          data.jobs.map((j) => (
                            <option key={j.id} value={j.id} selected={filter.job === parseInt(j.id)}>
                              {j.name}
                            </option>
                          ))}
                      </select>
                    )}
                  </Col>
                  <Col xs={3} className="text-end">
                    <Button variant="success" onClick={() => setMode(1)}>
                      Add +
                    </Button>
                  </Col>
                </Row>

                {data.help.length === 0 && <div className="alert alert-info p-5 text-center">No Help Materials added yet!</div>}

                {data.help.length > 0 && (
                  <Table striped={true}>
                    <thead>
                      <tr>
                        <th style={{ width: "40px" }}>Sl.</th>
                        <th>Help Material</th>
                        <th className="d-none d-sm-table-cell">Job Category</th>
                        <th className="d-none d-sm-table-cell">Job</th>
                        <th className="d-none d-sm-table-cell" style={{ width: "160px" }}>
                          Added On
                        </th>
                        <th style={{ width: "100px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.help.map((help, idx) => (
                        <tr>
                          <td>{filter.start + idx + 1}</td>
                          <td>
                            {help.ftype === "link" && (
                              <img
                                className="clickable me-2"
                                height="25"
                                title="Click to Play"
                                src={`${process.env.PUBLIC_URL}/images/video.png`}
                                onClick={() => setShowVideo(help.fname)}
                              />
                            )}
                            {help.ftype === "ext_link" && (
                              <a href={help.fname} target="_blank">
                                {" "}
                                🔗
                              </a>
                            )}
                            {help.ftype === "upload" && (
                              // <a title="Download" className="me-2" href={Utils.apiUrl("help/download") + "?fname=" + help.fname}>
                              <a title="Download" target="_blank" href={Utils.viewerLink(help.fname, `help/download?fname=${help.fname}`)}>
                                <img src={Utils.getFileIcon(_.get(help, "fname", ""))} height="25" alt="Download" />
                              </a>
                            )}

                            {help.title}
                          </td>
                          <td className="d-none d-sm-table-cell">{help.jcatname}</td>
                          <td className="d-none d-sm-table-cell">{help.jobname}</td>
                          <td className="d-none d-sm-table-cell">{help.created_at}</td>
                          <td>
                            <div className="d-flex">
                              <div className="form-check form-switch clickable" title={`Click to ${help.is_active === "1" ? "Disable" : "Enable"}`}>
                                <input
                                  onClick={(e) => toggleData(e, help)}
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  defaultChecked={help.is_active == "1"}
                                />
                              </div>
                              <img
                                width="22"
                                src={`${process.env.PUBLIC_URL}/images/edit.png`}
                                className="p-1 me-2 clickable"
                                title="Edit Help Material"
                                onClick={() => {
                                  setSelectedData(help);
                                  setMode(2);
                                }}
                              />
                              <img
                                width="20"
                                src={`${process.env.PUBLIC_URL}/images/delete.png`}
                                className="p-1 clickable"
                                onClick={(e) => handleDelete(e, help)}
                                title="Delete Help Material"
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </>
            )}
          </>
        )}
      </div>

      {showVideo !== "" && showVideoDialog()}

      {message && (
        <MessageModal
          type={message.type}
          message={message.message}
          onHide={() => {
            setMessage(false);
          }}
        />
      )}
    </>
  );
};

export default HelpMatManage;
